import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_prov_comm_and_training_on_social_and_labor_practic'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_prov_comm_and_training_on_social_and_labor_practic',
  name: 'Does the facility provide communication and training on social and labor practices?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'COMMUNICATION_AND_TRAINING_BASED_UPON_WRITTEN_POLICIES_AND_OR_P',
      text: 'Communication and training based upon written policies and/or procedures',
      externalIds: [
        {
          id: 'ms-5-1x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'COMMUNICATION_AND_TRAINING_BASED_UPON_INFORMAL_NOT_WRITTEN_PROC',
      text: 'Communication and training based upon informal (not written) procedures',
      externalIds: [
        {
          id: 'ms-5-2x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'THE_FACILITY_DOES_NOT_PROVIDE_COMMUNICATION_AND_TRAINING_ON_SOC',
      text: 'The facility does not provide communication and training on social and labor practices',
      externalIds: [
        {
          id: 'ms-5-3x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'COMMUNICATION_AND_TRAINING_BASED_UPON_WRITTEN_POLICIES_AND_OR_P',
                'COMMUNICATION_AND_TRAINING_BASED_UPON_INFORMAL_NOT_WRITTEN_PROC',
                'THE_FACILITY_DOES_NOT_PROVIDE_COMMUNICATION_AND_TRAINING_ON_SOC',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-do-6',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 21340,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
